import { IAPIAction } from "us.common/interfaces";
import { DocumentsManagerHistory } from "us.collection.input-output/constants";
import { IDocumentsManagerHistoryAction } from "us.collection.input-output/interfaces";

export const documentsManagerHistory: Readonly<
  IAPIAction & IDocumentsManagerHistoryAction
> = {
  assignedDocuments: {
    get: (data) => ({
      type: DocumentsManagerHistory.GET_ASSIGNED_DOCUMENTS_HISTORY,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: DocumentsManagerHistory.GET_ASSIGNED_DOCUMENTS_HISTORY_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: DocumentsManagerHistory.GET_ASSIGNED_DOCUMENTS_HISTORY_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    delete: (data: any) => ({
      type: DocumentsManagerHistory.DELETE_ASSIGNED_DOCUMENTS,
      payload: {
        data,
        isLoading: true as const,
      },
    }),
    deleteSuccess: (data) => ({
      type: DocumentsManagerHistory.DELETE_ASSIGNED_DOCUMENTS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    deleteFail: (error) => ({
      type: DocumentsManagerHistory.DELETE_ASSIGNED_DOCUMENTS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  documentContent: {
    get: (data) => ({
      type: DocumentsManagerHistory.GET_ASSIGNED_DOCUMENT_CONTENT,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: DocumentsManagerHistory.GET_ASSIGNED_DOCUMENT_CONTENT_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: DocumentsManagerHistory.GET_ASSIGNED_DOCUMENT_CONTENT_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
